<template>
	<div
		v-bind:class="[
			{
				'builder-element': !onPreview,
				'hide-desktop': node.options.visible_desktop,
				'hide-mobile': node.options.visible_mobile,
			},
			node.class,
		]"
		:id="node.id"
		:data-key="node.key"
		:data-elIcon="node.icon"
		:data-elName="node.name"
		:data-type="node.type"
		@click="onNodeClick(node)"
		:style="getWrapperStyle(node)"
	>
		<NodeAction :node="node" component="element" v-if="!onPreview" />
		<div :class="getWrapperClass(node)">
			<a
				:href="node.options.link || '#'"
				@click.stop.prevent
				class="d-inline-block"
				:class="getClass(node)"
				:style="getStyle(node)"
				:target="node.options.inNewTab ? '_blank' : '_self'">
				<!-- <div v-html="node.options && node.options.content"> -->
				<div>
					<NodeEditor
						:key="node.key"
						v-model="node.options.content"
						@focus="onNodeClick(node)"
					/>
				</div>
			</a>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import NodeAction from '@/components/funnels/pagebuilder/nodes/NodeAction.vue';
// eslint-disable-next-line
import NodeEditor from '@/components/funnels/pagebuilder/nodes/NodeEditor.vue';
import {
	getNodeStyle,
	// eslint-disable-next-line
} from '@/lib/helper';

export default {
	name: 'NodeLink',
	props: ['node', 'onPreview', 'previewDevice'],
	components: {
		NodeAction,
		NodeEditor,
	},
	computed: {},
	methods: {
		...mapActions({
			setActionElement: 'funnels/setActionElement',
		}),
		getWrapperClass({ options }) {
			let pClass = '';
			if (options && options.align) {
				pClass += ` text-${options.align}`;
			}

			return pClass;
		},
		getClass(node) {
			let pClass = node.class || '';
			if (node.options && node.options.align) {
				pClass += ` text-${node.options.align}`;
			}

			return pClass;
		},
		getStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'text-color',
				'font-family',
				'font-weight',
				'font-size',
				'font-style',
				'text-decoration',
				'line-height',
				'padding',
				'border',
				'box-shadow',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		getWrapperStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'margin',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		onNodeClick(node) {
			this.handleAction('edit', node);
		},
		handleAction(type, node) {
			this.$bus.$emit('action-element', type, node);
			// this.setActionElement({ type, node });
		},
	},
};
</script>

<style scoped></style>
